// src/pages/Home.js
import React from "react";
import "../styles/css/style.css";
import "../styles/css/bootstrap.min.css";
import Header from "../components/Header";
import AboutHero from "../components/AboutHero";
import Industries from "../components/Industries";
import Team from "../components/Team";
import Partners from "../components/Partners";
import Footer from "../components/Footer";
import VisionMissionValues from "../components/VisionMissionValues";



const Home = () => {

  return (
    <>
      <Header/>
      <AboutHero/>
      <Industries/>
      <Partners />
      <Team />
      <VisionMissionValues />
      <Footer />

    </>
  );
};

export default Home;
